import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { listServers, me, type ServerRow } from "../api/auth";
import { ServerEntryCard } from "../ui/ServerEntryCard";

export function AccountHomePage() {
  const { state, api } = useAuth();
  const [detail, setDetail] = useState<Awaited<ReturnType<typeof me>> | null>(null);
  const [servers, setServers] = useState<ServerRow[] | null>(null);

  useEffect(() => {
    me(api).then(setDetail).catch(() => setDetail(null));
  }, [api]);

  useEffect(() => {
    listServers(api).then((r) => setServers(r.servers)).catch(() => setServers([]));
  }, [api]);

  return (
    <div className="vstack">
      <div>
        <h1>{state.account?.display_name}</h1>
        <p className="meta">{state.account?.email} · {state.account?.role}</p>
      </div>

      <div className="card">
        <h2>Security</h2>
        {detail ? (
          detail.account.two_factor_enabled ? (
            <p className="ok">Two-factor authentication is enabled.</p>
          ) : (
            <div className="hstack">
              <span className="meta">Two-factor authentication is not enabled.</span>
              <Link className="btn primary" to="/2fa/enroll">Enable 2FA</Link>
            </div>
          )
        ) : (
          <p className="meta">Loading…</p>
        )}
      </div>

      <div className="card">
        <h2>Installs</h2>
        {servers === null && <p className="meta">Loading…</p>}
        {servers !== null && servers.length === 0 && (
          <p className="meta">No Prism installs paired yet. <Link to="/servers">Pair one</Link>.</p>
        )}
        {servers !== null && servers.length > 0 && (
          <div className="vstack" style={{ gap: 24 }}>
            {servers.map((s) => (
              <div className="row" key={s.id} style={{ flexDirection: "column", alignItems: "stretch" }}>
                <ServerEntryCard
                  id={s.id}
                  label={s.label}
                  serverId={s.server_id}
                  relationship={s.relationship}
                  lastLanIp={s.last_lan_ip ?? null}
                  lastLanPort={s.last_lan_port ?? null}
                  lastSeenAt={s.last_seen_at}
                  autoConnect={servers.length === 1}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Quiet, non-prominent — a danger surface, not a promoted action.
          Kept off the top nav deliberately; see DeleteAccountPage. */}
      <div>
        <Link className="subtle" to="/delete-account">Delete account</Link>
      </div>
    </div>
  );
}
